import { useCallback, useEffect } from "react";
import { isAuthenticated } from "../services/Auth";
import { apiNiches } from "../services";
import { useFetch } from "./useFetch";

export const useFollowingNichesQuery = () => {
  const fetchFollowingNiches = useCallback(() => apiNiches.getFollowingNiches(), []);
  const { data, isLoading, error, execute } = useFetch(fetchFollowingNiches, false);

  useEffect(() => {
    (async () => {
      try {
        if (await isAuthenticated()) {
          execute();
        }
      } catch (err) {
        console.error("Error checking authentication:", err);
      }
    })();
  }, [execute]);

  return {
    niches: data ? data.niches : [],
    isLoading,
    error,
  };
};
